var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{staticClass:"text-center mt-10"},[(_vm.error === null)?_c('v-col',[_c('p',{staticClass:"text-body-1"},[_vm._v("Logging in...")]),_c('v-progress-circular',{attrs:{"size":50,"indeterminate":""}})],1):_c('v-col',[_c('v-alert',{attrs:{"text":"","type":"error"}},[_vm._v("Error logging in: "+_vm._s(_vm.error))])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }